import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Modal.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, item, boxNumber }) => {
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const modalVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.8,
      y: 50
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 25
      }
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      y: 50,
      transition: { duration: 0.2 }
    }
  };

  if (!item) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          variants={overlayVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={onClose}
        >
          <motion.div
            className="modal-content confirmation-modal"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <motion.div 
                className="modal-icon"
                animate={{ 
                  rotate: [0, -10, 10, -10, 0],
                  scale: [1, 1.1, 1]
                }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                {item.image}
              </motion.div>
              <h2 className="modal-title">Confirm Your Bet</h2>
            </div>

            <div className="modal-body">
              <div className="confirmation-details">
                <div className="detail-row">
                  <span className="detail-label">Item</span>
                  <span className="detail-value">{item.name}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Box Selected</span>
                  <span className="detail-value highlight">Box {boxNumber}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Possible Win</span>
                  <span className="detail-value gold">{item.maxPrize}</span>
                </div>
                <div className="detail-divider" />
                <div className="detail-row total">
                  <span className="detail-label">Amount to Pay</span>
                  <span className="detail-value amount">KES {item.cost}</span>
                </div>
              </div>

              <p className="confirmation-note">
                You will receive an M-Pesa payment request on your phone.
              </p>
            </div>

            <div className="modal-footer">
              <motion.button
                className="btn btn-secondary"
                onClick={onClose}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Cancel
              </motion.button>
              <motion.button
                className="btn btn-primary"
                onClick={onConfirm}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <span>Confirm & Pay</span>
                <span className="btn-icon">💳</span>
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationModal;

